// extracted by mini-css-extract-plugin
module.exports = {"givePriority":"styles_givePriority__1J5uy","comparisonSelect":"styles_comparisonSelect__beByn","input":"styles_input__XCEdZ"};